<header class="top-header">
  <div class="header-left">
    <!--    <button class="btn-menu" (click)="toggleSidebar()">
            <i class="bi bi-list"></i>
        </button>  -->
    @if(user){
    <div class="user-info">
      <img
        [src]="user.image"
        [alt]="user.first_name + ' ' + user.last_name"
        onerror="this.src = 'assets/images/dummy.png'"
      />
      <span class="user-name">{{ user.first_name }} {{ user.last_name }}</span>
    </div>
    }
  </div>
  <div class="header-right">
    <div
      class="nav-link logout-btn"
      (click)="logout()"
      placement="bottom"
      ngbTooltip="Cerrar sesión"
    >
      <i class="bi bi-box-arrow-right"></i>
    </div>
  </div>
</header>
